<template>
  <div class="header">
    <div class="navigation-bar">
      <div class="n_left">
        <a
          title="Logo"
          @click="$router.push('/newprofile/projects')"
          class="logo"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="262.46"
            height="64.263"
            viewBox="0 0 262.46 64.263"
          >
            <g
              id="Group_77"
              data-name="Group 77"
              transform="translate(-461.499 -572.89)"
            >
              <g id="Group_76" data-name="Group 76">
                <g id="Group_74" data-name="Group 74">
                  <path
                    id="Path_142"
                    data-name="Path 142"
                    d="M698.585,613.555a23.353,23.353,0,1,1-11.546-20.549,1.208,1.208,0,0,1,.669,1.71c-1.313,4.286.784,9.912,6.691,10.4a6.535,6.535,0,0,0,.777.041c2.055-.082,2.035-.079,2.595,1.982A24.6,24.6,0,0,1,698.585,613.555Zm-13.809-.176a9.959,9.959,0,0,0-9.889-10.217c-5.7.1-9.769,4.518-9.733,10.463a9.979,9.979,0,0,0,9.886,10.082C680.535,623.681,684.8,619.152,684.776,613.379Z"
                    fill="#fff"
                  />
                </g>
                <path
                  id="Path_143"
                  data-name="Path 143"
                  d="M652.987,628.518a26.478,26.478,0,0,1-.081-30.012c.6-.884.451-1.351-.248-2.014a22.866,22.866,0,0,0-16.6-6.642,24.369,24.369,0,0,0-3.039.229,22.651,22.651,0,0,0-12.07,5.241,32.325,32.325,0,0,1,3.3,14.5c0,7.5-2.356,14.235-6.1,18.893a23.155,23.155,0,0,0,16.44,8.328,23.547,23.547,0,0,0,18.267-6.83C653.466,629.61,653.486,629.244,652.987,628.518Zm-16.849-4.8a10.294,10.294,0,1,1,9.8-10.3A10.093,10.093,0,0,1,636.138,623.717Z"
                  fill="#fff"
                />
                <g id="Group_75" data-name="Group 75">
                  <path
                    id="Path_144"
                    data-name="Path 144"
                    d="M470.215,587.992h12.327l-8.716,47.072H461.5Z"
                    fill="#fff"
                  />
                  <path
                    id="Path_145"
                    data-name="Path 145"
                    d="M526.557,620.135c0,10.222-8.777,14.929-19.983,14.929H482.605l8.716-47.072h22.038c9.837,0,15.129,3.967,15.129,11.028,0,5.649-3.051,9.617-7.783,11.768A9.745,9.745,0,0,1,526.557,620.135Zm-12.264-.268c0-2.825-2.117-3.968-5.105-3.968H498.293l-1.743,9.549h10.708C511.554,625.448,514.293,623.632,514.293,619.867Zm-12.576-22.259-1.681,9.078h8.841c4.358,0,6.723-1.882,6.723-5.38,0-2.555-1.93-3.7-5.167-3.7Z"
                    fill="#fff"
                  />
                  <path
                    id="Path_146"
                    data-name="Path 146"
                    d="M549.408,598.281l-1.432,7.935h19.362l-1.8,9.952H546.109l-1.557,8.607H567.4l-1.992,10.289H530.482l8.716-47.072h34.116l-1.93,10.289Z"
                    fill="#fff"
                  />
                  <path
                    id="Path_147"
                    data-name="Path 147"
                    d="M606,610.519H616.9l-3.674,19.838a27.265,27.265,0,0,1-17.182,5.648c-13.323,0-21.914-8.406-21.914-20.711,0-16.341,11.144-28.243,27.7-28.243,8.716,0,15.067,3.025,18.989,8.674l-8.841,7.532c-2.863-3.833-6.225-5.178-10.708-5.178-8.965,0-14.692,6.926-14.692,16.34,0,6.322,3.984,10.558,11.144,10.558a14.386,14.386,0,0,0,5.79-1.143Z"
                    fill="#fff"
                  />
                </g>
                <path
                  id="Path_148"
                  data-name="Path 148"
                  d="M471.147,578.817a5.965,5.965,0,0,1,5.906-5.927,6.063,6.063,0,0,1,5.985,5.889,5.991,5.991,0,0,1-5.846,5.994A5.871,5.871,0,0,1,471.147,578.817Z"
                  fill="#5cc3b9"
                />
              </g>
              <path
                id="Path_149"
                data-name="Path 149"
                d="M683.512,576.6a15.071,15.071,0,0,1,6.538,3.759A15.94,15.94,0,0,1,695.3,592.7a14.224,14.224,0,0,0,.844,5.918,10.229,10.229,0,0,0,10.272,6.2c4.621-.478,6.151-1.121,10.422-4.17-.547,1.453-.982,2.961-1.661,4.349a16.682,16.682,0,0,1-31.715-7.3c-.028-6.745-.021-13.49-.022-20.235C683.444,577.215,683.483,576.962,683.512,576.6Z"
                fill="#101c2b"
              />
              <path
                id="Path_150"
                data-name="Path 150"
                d="M685.372,578.7a13.388,13.388,0,0,1,5.807,3.339,14.154,14.154,0,0,1,4.666,10.967,12.64,12.64,0,0,0,.75,5.256,9.082,9.082,0,0,0,9.123,5.5c4.1-.424,5.463-.995,9.256-3.7-.486,1.291-.872,2.63-1.475,3.863a14.817,14.817,0,0,1-28.168-6.479c-.025-5.991-.018-11.981-.019-17.972C685.312,579.248,685.346,579.023,685.372,578.7Z"
                fill="#5cc3b9"
              />
              <path
                id="Path_151"
                data-name="Path 151"
                d="M700.309,598.664c-.646-5.61.554-10.683,4.3-15.02a18.548,18.548,0,0,1,14.391-6.626c1.423-.019,2.846-.042,4.268-.011.242.005.691.285.686.424a29.378,29.378,0,0,1-.377,5.6c-.62,2.638-3.386,4.426-6.091,4.556-7.6.366-13.242,3.865-16.786,10.649a4.709,4.709,0,0,1-.257.411C700.437,598.663,700.391,598.655,700.309,598.664Z"
                fill="#5cc3b9"
              />
            </g>
          </svg>
        </a>
        <!--        <router-link class="nbar_button" to="mainStoryView" title="Back to Main Story">
                  <i class="fa fa-arrow-left"></i>
                </router-link>
                <a title="Add Track" href="#" class="add-button nbar_button"></a>-->
                
        <!-- <a title="Undo" href="#" class="undo-button nbar_button"></a>
        <a title="Redo" href="#" class="redo-button nbar_button"></a>
        <a title="Filter" href="#" class="filter-button nbar_button"></a>
        <a
          title="Backup"
          href="#"
          class="version-control-button nbar_button"
        ></a>
        <a
          title="Add Track"
          href="#"
          class="move-folder-button nbar_button"
        ></a> -->
        <div class="last-saved-info">
          <ol class="breadcrumb mb-0">
            <li class="breadcrumb-item" aria-current="page">
              <router-link to="/newprofile/projects"
                >Projects Gallery</router-link
              >
            </li>
            <li class="breadcrumb-item" aria-current="page">
              <a @click="viewStoryDetail" >
                {{ this.selectedStoryTitle }} Dashboard
              </a>
            </li>
            <li class="breadcrumb-item" aria-current="page">
              <router-link to="/mainStoryView"> Decision Tree </router-link>
            </li>
            <li 
              class="breadcrumb-item previous-li"
              aria-current="page"
              v-if="this.selectedLogic && this.previousNode"
            >
             <a  @click="goToNode(previousNode)"> {{ previousNode.name.replace(/([a-z])(\d)/gi, '$1 $2') }}</a>
            </li>
            <li
              class="breadcrumb-item current-li"
              aria-current="page"

              v-if="this.selectedLogic"
              :style="`color : ${color[selectedLogic.category]}`"
            >
              {{ this.selectedLogic.name.replace(/([a-z])(\d)/gi, '$1 $2') }}
            </li>
            <li
              class="breadcrumb-item next-li"
              aria-current="page"
              v-if="this.selectedLogic && nextNode.length>0"
            >
            <div v-if="nextNode.length>1" class="dropdown">
                <button class="dropbtn">Multi-Scenes 
                <i class="fa fa-caret-down"></i>
                </button>
              <div class="dropdown-content">
                  <a v-for="(nextnode, index) in nextNode" @click="goToNode(nextnode)"> {{ nextnode.name.replace(/([a-z])(\d)/gi, '$1 $2') }}</a>
              </div>
            </div>
              <a  v-else @click="goToNode(nextNode[0])">  {{ nextNode[0].name.replace(/([a-z])(\d)/gi, '$1 $2') }}</a>
          </li>
          </ol>
        </div>
      </div>
      <div class="n_center"></div>
      <!-- <div class="n_right"> -->
        <!-- <a title="Share" href="#" class="share-button nbar_button"></a> -->
        <!--          <a title="Search" href="#" class="search-button nbar_button"></a>
          <a title="Toggle Logic" href="#" class="timeline-button-toggle nbar_button"
             @click="$parent.togglePanel('logic')"></a>
          <a title="Toggle Preview" href="#" class="preview-button-toggle nbar_button"
             @click="$parent.togglePanel('preview')"></a>
          <a title="Toggle Inspector" href="#" class="inspector-toggle-button nbar_button"
             @click="$parent.togglePanel('inspector')"></a>-->

        <!-- <div class="dropdown d-none">
          <div class="form-group mb-0">
            <select class="custom-select" v-model="$parent.layout_type">
              <option value="default">Default</option>
              <option value="horizontal">Horizontal</option>
              <option value="vertical">Vertical</option>
            </select>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
import { db } from "../../../firebaseDB";
export default {
  components: {},
  data() {
    return {
      selectedLogic: null,
      previousNode:'',
      nextNode:[],
      selectedStoryTitle: null,
      color : { 
        Scene : "#ff99c8",
        Page : "#fcf6bd",
        Logic : "#d0f4de",
      }
    };
  },
  created() {
    this.selectedLogic = JSON.parse(localStorage.getItem("selectedLogic"));
    let tRef = db.ref().child("stories/" + localStorage.getItem("storyId"));
    tRef.on("value", (snapshot) => {
      let json = snapshot.val() && snapshot.val().json;
      if (json && json.storyName) {
        this.selectedStoryTitle = json.storyName;
        if(Object.keys(this.selectedLogic).length == 4){
        let previousNodeIndex = json.mainStory.nodes.findIndex((node) => node.name === snapshot.val().diagram.linkDataArray.filter( (node) => node.to === this.selectedLogic.name)[0].from);
        this.previousNode = json.mainStory.nodes[previousNodeIndex]
        let nextNodeIndex
        if(snapshot.val().diagram.linkDataArray.filter( (node) => node.from === this.selectedLogic.name)[0]){
         nextNodeIndex = json.mainStory.nodes.findIndex((node) => node.name === snapshot.val().diagram.linkDataArray.filter( (node) => node.from === this.selectedLogic.name)[0].to) ;
      if(json.mainStory.nodes.filter((node) => node.name === this.selectedLogic.name)[0].nodeType=='LogicNode'){
        let this_ = this
        if(json.mainStory.nodes.filter((node) => node.name === this.selectedLogic.name)[0].conditions[0].conditionType=="STT" ){
          json.mainStory.nodes.filter((node) => node.name === this.selectedLogic.name)[0].conditions.forEach(function (value, index) {
           this_.nextNode.push(json.mainStory.nodes[value.stt.nextNodeID])
          })
        }else if(json.mainStory.nodes.filter((node) => node.name === this.selectedLogic.name)[0].conditions[0].conditionType=="Probability" ){
          json.mainStory.nodes.filter((node) => node.name === this.selectedLogic.name)[0].conditions.forEach(function (value, index) {
           this_.nextNode.push(json.mainStory.nodes[value.probability.nextNodeID])
          })
        }
        else if(json.mainStory.nodes.filter((node) => node.name === this.selectedLogic.name)[0].conditions[0].conditionType=='Touch'){
         if( json.mainStory.nodes.filter((node) => node.name === this.selectedLogic.name)[0].conditions.length>0){
          json.mainStory.nodes.filter((node) => node.name === this.selectedLogic.name)[0].conditions.forEach(function (value, index) {
           this_.nextNode.push(json.mainStory.nodes[value.touch.nextNodeID])
          })
          }else{
             this.nextNode.push(json.mainStory.nodes[nextNodeIndex])
          }
        }
      }else if(json.mainStory.nodes.filter((node) => node.name === this.selectedLogic.name)[0].nodeType=='SceneNode' 
      && json.mainStory.nodes.filter((node) => node.name === this.selectedLogic.name)[0].nextNodeID!=-1){
        this.nextNode.push(json.mainStory.nodes[nextNodeIndex])
      }
        }
       }
      }
      console.log(this.nextNode);
      console.log(this.previousNode);
    });
  },
  methods: {
    goToNode(data){
           let storyData = this.$store.state.stories.filter( (story) => story.id === localStorage.getItem("storyId") )[0]
     const nodeDataArray = storyData.diagram.nodeDataArray
      const nodePosition = nodeDataArray.findIndex((n) => n.key == data.key);
       const nodedata = nodeDataArray.filter((n) => n.key == data.name)[0];
      let selectedNode = {
        key: nodedata.key,
        name: nodedata.key,
        category: nodedata.category,
        nodePosition: nodePosition,
      };
      localStorage.setItem("selectedLogic", JSON.stringify(selectedNode));
      this.$store.dispatch("listUserStories");
      if (data && data.name.startsWith("Logic")) {
        this.$router.push("logicEditView");
      } else {
        if(this.$router.currentRoute.name!='storyEditView'){
        this.$router.push("storyEditView");
        }else{
         this.$router.go(this.$router.currentRoute)
        }
      }
    
    },
    viewStoryDetail() {
      this.$router.push({
        name: "project-dashboard",
        query: {
          title: this.selectedStoryTitle,
          id: localStorage.getItem("storyId"),
        },
      });
    },
  },
  beforeMount() {
    console.log(this.$store.state.selectedLogic);
  },
  mounted() {},
  watch: {},
  computed: {},
};
</script>
<style lang="scss" scoped>
    .header {
      z-index: 6;
      position: sticky;
      top: 0;
      z-index: 1000;
  }
  ol li,  ol li a  {
    color : #6c757d ;
  }
  .current-li {
    position : relative;
    &:after {
      content : "";
      border : 2px solid;
      padding : 1rem;
      position : absolute;
      top: -6px;
      bottom: 0;
      right: -1px;
      left: 1px;
      border-radius: 0.5rem;
    }
    }
.current-li,.next-li{
  &:before {
      content : "";
    }
}

@media screen and  (max-width: 820px) {
  .header {
    display: none;
  }
}
.dropdown {
  float: left;
  overflow: hidden;
}

.navigation-bar {
    z-index: 1000;
}


.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  z-index: 1;
}

.dropdown-content a {
  float: none;
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
  text-align: left;
}


.dropdown:hover .dropdown-content {
  display: block;
  position: fixed;
  min-width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/v2/story-edit-view/header.vue